module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    },
    on: {
      "save": _vm.fetchOrderStatuses
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Identificador da conta",
      "error": _vm.getError('auth.accountId')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.accountId),
      expression: "config.auth.accountId"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Digite o identificador da sua conta"
    },
    domProps: {
      "value": (_vm.config.auth.accountId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "accountId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Esse identificador pode ser encontrado no painel administrativo da Ecomece.")])])], 1), _vm._v(" "), _c('div', [_c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar produtos automaticamente"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.synchronize),
      expression: "config.product.synchronize"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.synchronize) ? _vm._i(_vm.config.product.synchronize, null) > -1 : (_vm.config.product.synchronize)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.synchronize,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "synchronize", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "synchronize", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "synchronize", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os produtos da fonte de dados devem ser sincronizados\n            automaticamente.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar apenas produtos ativos"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.lookupOnlyStatusActive),
      expression: "config.product.lookupOnlyStatusActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.product.lookupOnlyStatusActive) ? _vm._i(_vm.config.product.lookupOnlyStatusActive, null) > -1 : (_vm.config.product.lookupOnlyStatusActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.product.lookupOnlyStatusActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.product, "lookupOnlyStatusActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.product, "lookupOnlyStatusActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.product, "lookupOnlyStatusActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se apenas produtos ativos na fonte de dados devem ser sincronizados.")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Variações"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Cor",
      "error": _vm.getError('config.variationTemplate.color')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.variationTemplate.color),
      expression: "config.variationTemplate.color"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.variationTemplate, "color", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.attributes), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tamanho",
      "error": _vm.getError('config.variationTemplate.size')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.variationTemplate.size),
      expression: "config.variationTemplate.size"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.variationTemplate, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.attributes), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Voltagem",
      "error": _vm.getError('config.variationTemplate.voltage')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.variationTemplate.voltage),
      expression: "config.variationTemplate.voltage"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.variationTemplate, "voltage", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.attributes), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sabor",
      "error": _vm.getError('config.variationTemplate.flavor')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.variationTemplate.flavor),
      expression: "config.variationTemplate.flavor"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.variationTemplate, "flavor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.attributes), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)])], 1) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Atributos Adicionais"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Gênero",
      "error": _vm.getError('config.additionalAttributes.gender')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.additionalAttributes.gender),
      expression: "config.additionalAttributes.gender"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.additionalAttributes, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.specifications), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Faixa etária",
      "error": _vm.getError('config.additionalAttributes.ageGroup')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.additionalAttributes.ageGroup),
      expression: "config.additionalAttributes.ageGroup"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.additionalAttributes, "ageGroup", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.specifications), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Código do Fabricante",
      "error": _vm.getError('config.additionalAttributes.manufacturerReference')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.additionalAttributes.manufacturerReference),
      expression: "config.additionalAttributes.manufacturerReference"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.additionalAttributes, "manufacturerReference", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.specifications), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Tempo de garantia",
      "error": _vm.getError('config.additionalAttributes.warrantyTime')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.additionalAttributes.warrantyTime),
      expression: "config.additionalAttributes.warrantyTime"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.additionalAttributes, "warrantyTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.specifications), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Garantia",
      "error": _vm.getError('config.additionalAttributes.warranty')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.additionalAttributes.warranty),
      expression: "config.additionalAttributes.warranty"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.additionalAttributes, "warranty", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.specifications), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "NCM",
      "error": _vm.getError('config.additionalAttributes.ncm')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.additionalAttributes.ncm),
      expression: "config.additionalAttributes.ncm"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.additionalAttributes, "ncm", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.specifications), function(options) {
    return _c('option', {
      key: options.id,
      domProps: {
        "value": options.id
      }
    }, [_vm._v(_vm._s(options.label))])
  })], 2)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Status de pedidos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('a', {
    staticClass: "btn btn--info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.fetchOrderStatuses()
      }
    }
  }, [_c('i', {
    staticClass: "icon-spinner11"
  })])]), _vm._v(" "), (!_vm.fetching && _vm.statusesGroupedByType) ? _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.getStatusByIdentifier('default')), function(statusValue, statusName) {
    return (statusName !== 'identifier') ? _c('form-group', {
      key: statusName,
      attrs: {
        "label": _vm.$t((statusName + ".label"))
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.getStatusByIdentifier('default')[statusName]),
        expression: "getStatusByIdentifier('default')[statusName]"
      }],
      staticClass: "form-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.getStatusByIdentifier('default'), statusName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
      return _c('option', {
        key: status.code,
        domProps: {
          "value": status.code
        }
      }, [_vm._v(_vm._s(status.label) + "\n          ")])
    })], 2)]) : _vm._e()
  }), 1) : (!_vm.fetching) ? _c('div', {
    staticClass: "u-bolder t-error u-textCenter"
  }, [_vm._v("Não foi possível buscar os status dos pedidos da\n      Ecomece.\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Status de pedidos por marketplace"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('a', {
    staticClass: "btn btn--info",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.fetchOrderStatuses()
      }
    }
  }, [_c('i', {
    staticClass: "icon-spinner11"
  })])]), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _vm._l((_vm.modulesInstalled), function(module) {
    return _c('panel', {
      key: module,
      staticClass: "blue-panel",
      attrs: {
        "title": module.name,
        "useAcordion": true,
        "useToggleIcon": true
      }
    }, [_c('panel', [(!_vm.fetching && _vm.statusesGroupedByType) ? _c('div', {
      staticClass: "l-row"
    }, [_vm._l((_vm.getStatusByIdentifier(module.identifier)), function(statusValue, statusName) {
      return (statusName !== 'identifier' && statusName !== 'exchange') ? _c('form-group', {
        key: statusName,
        attrs: {
          "label": _vm.$t((statusName + ".label"))
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getStatusByIdentifier(module.identifier)[statusName]),
          expression: "getStatusByIdentifier(module.identifier)[statusName]"
        }],
        staticClass: "form-select",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.getStatusByIdentifier(module.identifier), statusName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
        return _c('option', {
          key: status.code,
          domProps: {
            "value": status.code
          }
        }, [_vm._v(_vm._s(status.label) + " ")])
      })], 2)]) : _vm._e()
    }), _vm._v(" "), _vm._l((_vm.getExchangeStatusByIdentifier(module.identifier)), function(statusValue, statusName) {
      return (_vm.haveExchangeStatuses(module.identifier)) ? _c('form-group', {
        key: statusName,
        attrs: {
          "label": _vm.$t(("exchange." + statusName + ".label"))
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.getExchangeStatusByIdentifier(module.identifier)[statusName]),
          expression: "getExchangeStatusByIdentifier(module.identifier)[statusName]"
        }],
        staticClass: "form-select",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(_vm.getExchangeStatusByIdentifier(module.identifier), statusName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        domProps: {
          "value": null
        }
      }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusesGroupedByType), function(status) {
        return _c('option', {
          key: status.code,
          domProps: {
            "value": status.code
          }
        }, [_vm._v(_vm._s(status.label) + "\n              ")])
      })], 2)]) : _vm._e()
    })], 2) : (!_vm.fetching) ? _c('div', {
      staticClass: "u-bolder t-error u-textCenter"
    }, [_vm._v("Não foi possível buscar os status dos pedidos da Ecomece.")]) : _vm._e()])], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c2521a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Ecomece.vue
// module id = 3285
// module chunks = 0